import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  allData: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'GuestCards',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getGuestCardSuccess(state, action) {
      state.data = action.payload.data;
    },
    getAllGuestCardSuccess(state, action) {
      state.allData = action.payload.data;
    },

    addOrUpdateGuestCard(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllGuestCard() {
  return async () => {
    try {
      const response = await get(`GuestCard`);
      if (response.status) {
        dispatch(slice.actions.getAllGuestCardSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getGuestCard() {
  return async () => {
    try {
      const response = await get(`GuestCard`);
      if (response.status) {
        dispatch(slice.actions.getGuestCardSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addGuestCard(body) {
  return async () => {
    try {
      const response = await post(`GuestCard`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateGuestCard(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateGuestCard(body) {
  return async () => {
    try {
      const response = await put(`GuestCard/${body?.id}`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateGuestCard(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
